<template> 
  <el-dialog
      customClass="customWidth"
      v-dialogDrag
      :title="title"
      :visible.sync="show"
      @close="onClose">
      <el-form ref="baseForm" label-width="120px" class="dialog-from flex" :rules="rules" :model="formData">
          <el-form-item class="item" label="物料类别编码：" prop="materialType">
            <el-input type="text" placeholder="请输入" v-model="formData.materialType"></el-input>
          </el-form-item>

          <el-form-item class="item" label="物料类别描述：" prop="materialTypeDesc">
            <el-input type="text" placeholder="请输入" v-model="formData.materialTypeDesc"></el-input>
          </el-form-item>

          <el-form-item class="item" label="起始段：" prop="startSegment" >
            <el-input type="text" placeholder="请输入" v-model="formData.startSegment"></el-input>
          </el-form-item>

          <el-form-item class="item" label="结束段：" prop="endSegment">
            <el-input type="text" placeholder="请输入" v-model="formData.endSegment"></el-input>
          </el-form-item>

          <el-form-item class="item" label="当前数：" prop="currentNumber">
            <el-input type="text" placeholder="请输入" v-model="formData.currentNumber" disabled></el-input>
          </el-form-item>

          <el-form-item class="item" label="步长：" prop="stepUnit">
            <el-input type="text" placeholder="请输入" v-model="formData.stepUnit"></el-input>
          </el-form-item>
       </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="onClose">取 消</el-button>
          <el-button type="primary" @click="onConfirm">确 定</el-button>
      </div>
    </el-dialog>
</template>
 
<script>

export default {
  components: {},
  props: {
    formData: {
      Type:Object,
      default(){
        return {}
      }
    },
    visible:{
      Type:Boolean,
      default(){
        return false
      }
    },
    title:{
      Type:String,
      default(){
        return '物料类型-新增'
      }
    }
  },
  watch:{
     visible(newVal,oldVal){
       this.show=newVal;
     }
  },
  data() {
    return {
      show:this.visible,
      regRes:false,
      textarea: "",
      rules: {
        materialType: [
          {
            required: true,
            message: "请输入物料编码",
            trigger: "blur"
          }
        ],
        materialTypeDesc: [
          {
            required: true,
            message: "请输入物料描述",
            trigger: "blur"
          }
        ],
        startSegment: [
          {
            required: true,
            pattern: /^\d+$/,
            message: "请输入正确的起始值(非负整数)",
            trigger: "blur"
          }
        ],
        endSegment: [
          {
            required: true,
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: "请输入正确的结束值(正整数)",
            trigger: "blur"
          }
        ],
        stepUnit: [
          {
            required: true,
            pattern: /^\d+$/,
            message: "请输入正确的步长值(非负整数)",
            trigger: "blur"
          }
        ]
        // tenantCode: [
        //   {
        //     required: true,
        //     message: "请输入租户代码",
        //     trigger: "blur"
        //   }
        // ],
        // tenantDesc: [
        //   {
        //     required: true,
        //     message: "请输入租户名",
        //     trigger: "blur"
        //   }
        // ],
        // legalPerson: [
        //   {
        //     required: true,
        //     message: "请输入法定人",
        //     trigger: "blur"
        //   }
        // ]
      }
    };
  },
  created() {
    
  },
  methods: {
    onClose(){
       let vm=this;
       vm.show=false,
       vm.$emit("onClose",vm);
    },
    /**
     * 提交
     */
    onConfirm(){
        let vm=this;
        vm.validataForm(function(){
            vm.$emit("onSubmit",vm.formData);
        }); 
    },
    validataForm(cb){
      let vm=this;
      vm.$refs['baseForm'].validate((vaild)=>{
          if(vaild){
              if(cb){
                  cb();                
              }            
          }
      });
    }
  }
};
</script>

<style>
</style>
